"use strict";

const { storageEntriesToLua } = require("./lua-analyzer/storage-meta.js");

const EVENT_ARGS = {
    RaidEvent: "ActivityModel",
    SubEvent: "ActivityModel",
    RedeemEvent: "ActivityModel",
    BitsEvent: "ActivityModel",
    FollowEvent: "ActivityModel",
    BadwordEvent: "BadWordEventMessage",
    WordEvent: "ObservedWordEventMessage",
    MessageEvent: "PrivateMessage",
    EmoteEvent: "EmoteEventMessage",
    StreamStateChangeEvent: "StreamState",
    StreamOnlineEvent: "StreamState",
    StreamOfflineEvent: "StreamState",
    WebhookEvent: "WebhookReceiverMessage",
    UserCommandWakeupEvent: "table",
};

const STUBS = [
    { name: "globals.lua", text: require("../../../lua-lib/globals.lua") },
    { name: "types.lua", text: require("../../../lua-lib/types.lua") },
    { name: "bot.lua", text: require("../../../lua-lib/bot.lua") },
    { name: "http.lua", text: require("../../../lua-lib/http.lua") },
    { name: "storage.lua", text: require("../../../lua-lib/storage.lua") },
    { name: "json.lua", text: require("../../../lua-lib/json.lua") },
    { name: "log.lua", text: require("../../../lua-lib/log.lua") },
    { name: "ai.lua", text: require("../../../lua-lib/ai.lua") },
    { name: "command.lua", text: require("../../../lua-lib/command.lua") },
    { name: "datetime.lua", text: require("../../../lua-lib/datetime.lua") },
];

function argsStub(eventType) {
    const ty = EVENT_ARGS[eventType] || "table";
    return "---@meta\n---@type " + ty + "\nargs = args\n";
}

function getLibraryFiles(eventType, storageLua) {
    const files = STUBS.map((s) => ({ name: s.name, text: s.text, library: true }));
    files.push({ name: "args.lua", text: argsStub(eventType), library: true });
    if (storageLua) {
        files.push({ name: "storage-meta.lua", text: storageLua, library: true });
    }
    return files;
}

module.exports = {
    EVENT_ARGS,
    getLibraryFiles,
    storageEntriesToLua,
    argsStub,
};
